import { formatDistance, isValid, parseISO } from 'date-fns';

import { Icon } from '@/components/icon';

import styles from './reference-block.module.scss';

export interface LinearReferenceProps {
  url: string;
  content: string;
  date: string;
  onOpen?: () => void;
}

export const LinearReference = ({ url, content, date, onOpen }: LinearReferenceProps) => {
  const relativeTime = isValid(parseISO(date ?? ''))
    ? formatDistance(new Date(date), new Date(), { addSuffix: true })
    : '';

  return (
    <div className={styles.linearBlock}>
      <div className={styles.icon}>
        <Icon name="Linear" size={32} />
      </div>
      <div className={styles.title}>{content}</div>
      <a
        href={url}
        rel="noopener noreferrer nofollow"
        target="_blank"
        className={styles.iconLink}
        draggable={false}
        onClick={onOpen}>
        <Icon name="ExternalLink" size={14} />
      </a>
      <div className={styles.subtitle}>{relativeTime}</div>
    </div>
  );
};
